export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14372.f2f0209b.jpg";